export const ease = [0.25, 0.1, 0.25, 1];
export const easeScan = [0.65, 0, 0.35, 1];
export const springSnappy = { type: 'spring', stiffness: 300, damping: 25 };
export const springCard = { type: 'spring', stiffness: 300, damping: 20 };

export const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } },
};

export const slideLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.7, ease } },
};

export const slideRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.7, ease } },
};

export const staggerContainer = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.14 } },
};

export const staggerItem = {
    hidden: { opacity: 0, y: 28 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.55, ease } },
};

export const heroContainer = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.2, delayChildren: 0.3 } },
};

export const heroItem = {
    hidden: { opacity: 0, y: 28 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.75, ease } },
};
